import React from 'react'
import Form from 'react-bootstrap/Form'
import { toKebabCase } from 'helpers/utils'
import { Row, Col } from 'react-bootstrap'
import FilterLabel from './FilterLabel'
import MutedText from './muted-text'

function CheckboxField({
  params,
  setParams,
  accessorKey,
  label,
  helperText = ''
}) {
  const checked = params[accessorKey] === true

  return (
    <Row className="mt-3 mb-3 d-flex">
      <Col sm={3}>
        <FilterLabel
          columnName={label}
          onClearClick={() =>
            setParams({ ...params, [accessorKey]: undefined })
          }
          isActive={checked}
        />
      </Col>
      <Col sm={9}>
        <Form.Check
          inline
          checked={checked}
          label={<MutedText as="div" className="ms-2">{helperText}</MutedText>}
          name={toKebabCase(label)}
          type={'checkbox'}
          onChange={() =>
            setParams({
              ...params,
              [accessorKey]: !params[accessorKey]
            })
          }
          id={`${toKebabCase(label)}-checkbox`}
        />
      </Col>
    </Row>
  )
}

export default CheckboxField
